import { useState } from 'react';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import MessageInput from './MessageInput';

const ChatWindow = ({ 
  agent, 
  messages, 
  isTyping,
  onClose, 
  onSendMessage, 
  isMobile, 
  getPositionStyles,
  getContrastColor,
  onEndChat,
  onStartNewChat,
  chatState,
  showForm
}) => {
  const [inputMessage, setInputMessage] = useState('');
  
  const primaryColor = agent?.widget_settings?.primary_color || "#4309ffff";
  const secondaryColor = agent?.widget_settings?.secondary_color || "#000000ff";

  const handleSendMessage = (message) => {
    onSendMessage(message);
    setInputMessage('');
  };

  return (
    <div 
  style={!isMobile ? getPositionStyles() : {}} 
  className={`${isMobile ? 'fixed inset-0 z-50' : 'fixed z-50 transition-all w-96'}`}
>
  <div className={`bg-white ${isMobile ? 'h-full flex flex-col' : 'rounded-3xl overflow-hidden shadow-md'}`}>
        <ChatHeader 
          agent={agent}
          isTyping={isTyping}
          onClose={onClose}
          onEndChat={onEndChat}
          primaryColor={primaryColor}
          title="Online"
          showCloseButton={true}
          showForm={showForm}
          chatState={chatState}
        />

        <MessageList 
          messages={messages}
          isTyping={isTyping}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          getContrastColor={getContrastColor}
          isMobile={isMobile}
          agentName={agent?.name}
          agentLogo={agent?.widget_settings?.logo_url}
          chatState={chatState}
        />

        <MessageInput 
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
          onSendMessage={handleSendMessage}
          onStartNewChat={onStartNewChat}
          isTyping={isTyping}
          primaryColor={primaryColor}
          chatState={chatState} 
        />
      </div>
    </div>
  );
};

export default ChatWindow;